import React from "react";
import css from "./Info.module.css";
import { useSession } from "../../../hooks/session";
import Spinner from "../../Spinner";
import PathwayInfoEntry, { PathwayInfoLink } from "./PathwayInfoEntry";
import { labelIdentifiers } from "../Config/Identifier";
import PathwayDescription from "./PathwayDescription";

const Info = ({ sessionId, selected }) => {
  const { data, isLoading } = useSession(sessionId);

  if (isLoading) return <Spinner />;

  return (
    <div className={css.info}>
      <ElementInfo selected={selected} />
      <PathwayInfo sessionData={data} />
    </div>
  );
};

export default Info;

const ElementInfo = ({ selected }) => {
  return (
    <div className={css.biologicalBox}>
      <div className={css.titleBiologicalBox}>Element Info</div>
      <div className={css.containerBiologicalBox}>
        <div className={css.contentBiologicalBox}>
          <ul>
            {selected.map((entry) => {
              return <li key={entry.key}>{entry.render}</li>;
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

const PathwayInfo = ({ sessionData }) => {
  const pathwayInfo = getPathwayInfo(sessionData);

  return (
    <div className={css.pathwayBox}>
      <div className={css.titlePathwayBox}>Pathway Info</div>
      <div className={css.containerPathwayBox}>
        <div className={css.contentPathwayBox}>
          <ul>
            {pathwayInfo.map((entry) => (
              <li key={entry.key}>{entry.render}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

function getPathwayInfo(sessionData) {
  const pathwayInfo = [];

  const nt = {};
  for (let i = 0; i < sessionData.allowed_network_types.length; i++) {
    nt[sessionData.allowed_network_types[i].value] =
      sessionData.allowed_network_types[i].name;
  }

  pathwayInfo.push({
    key: "Pathway Title",
    render: (
      <PathwayInfoEntry label={"Pathway Title"} value={sessionData.title} />
    ),
  });
  pathwayInfo.push({
    key: "Database",
    render: (
      <PathwayInfoEntry label={"Database"} value={sessionData.database} />
    ),
  });
  pathwayInfo.push({
    key: "Native ID",
    render: (
      <PathwayInfoLink
        label={"Native ID"}
        value={sessionData.nativeId}
        url={sessionData.url}
      />
    ),
  });
  pathwayInfo.push({
    key: "Species",
    render: (
      <PathwayInfoEntry
        label={"Species"}
        value={`${sessionData.species[0].toUpperCase()}. ${sessionData.species.slice(
          1
        )}`}
      />
    ),
  });

  pathwayInfo.push({
    key: "Node type",
    render: (
      <PathwayInfoEntry
        label={"Node type"}
        value={
          sessionData.protein_type === "NATIVE"
            ? `${sessionData.protein_type} (${
                labelIdentifiers[
                  sessionData.cy_network["nodes"][0]["data"]["node_type"]
                ]
              })`
            : labelIdentifiers[sessionData.protein_type]
        }
      />
    ),
  });

  pathwayInfo.push({
    key: "Network type",
    render: (
      <PathwayInfoEntry
        label={"Network type"}
        value={nt[sessionData.network_type]}
      />
    ),
  });

  pathwayInfo.push({
    key: "Description",
    render: (
      <PathwayDescription
        pathwayInternalId={sessionData.pathwayInternalId}
        label={"Description"}
      />
    ),
  });

  return pathwayInfo;
}
